// Componente Input con soporte para validación y estados de error
import { forwardRef, useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'

const Input = forwardRef(({
  label,
  error,
  hint,
  icon: Icon,
  type = 'text',
  className = '',
  containerClassName = '',
  ...props
}, ref) => {
  // Estado para alternar visibilidad de contraseña
  const [showPassword, setShowPassword] = useState(false)
  const isPassword = type === 'password'
  const inputType = isPassword ? (showPassword ? 'text' : 'password') : type

  return (
    <div className={containerClassName} style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
      {label && (
        <label
          className="font-body"
          style={{ fontSize: '0.875rem', fontWeight: 500, color: 'var(--color-text-secondary)' }}
        >
          {label}
        </label>
      )}
      <div style={{ position: 'relative' }}>
        {Icon && (
          <div
            style={{
              position: 'absolute',
              left: '12px',
              top: '50%',
              transform: 'translateY(-50%)',
              color: 'var(--color-text-muted)',
            }}
          >
            <Icon style={{ width: '16px', height: '16px' }} />
          </div>
        )}
        <input
          ref={ref}
          type={inputType}
          className={className}
          style={{
            width: '100%',
            padding: '10px 16px',
            paddingLeft: Icon ? '40px' : '16px',
            paddingRight: isPassword ? '40px' : '16px',
            borderRadius: '8px',
            background: 'var(--color-surface-card)',
            color: 'var(--color-text-primary)',
            border: error ? '1px solid #EF4444' : '1px solid var(--color-border-default)',
            fontSize: '0.875rem',
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            outline: 'none',
            transition: 'border-color 0.2s, box-shadow 0.2s',
            boxSizing: 'border-box',
          }}
          onFocus={(e) => {
            e.target.style.borderColor = error ? '#EF4444' : '#00C2FF'
            e.target.style.boxShadow = error
              ? '0 0 0 3px rgba(239, 68, 68, 0.15)'
              : '0 0 0 3px rgba(0, 194, 255, 0.15)'
          }}
          onBlur={(e) => {
            e.target.style.borderColor = error ? '#EF4444' : 'var(--color-border-default)'
            e.target.style.boxShadow = 'none'
          }}
          {...props}
        />
        {isPassword && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: 'absolute',
              right: '12px',
              top: '50%',
              transform: 'translateY(-50%)',
              color: 'var(--color-text-muted)',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
            }}
            tabIndex={-1}
            aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
          >
            {showPassword
              ? <EyeOff style={{ width: '16px', height: '16px' }} />
              : <Eye style={{ width: '16px', height: '16px' }} />
            }
          </button>
        )}
      </div>
      {error && (
        <p style={{ fontSize: '0.75rem', color: '#EF4444', margin: 0 }}>{error}</p>
      )}
      {hint && !error && (
        <p style={{ fontSize: '0.75rem', color: 'var(--color-text-muted)', margin: 0 }}>{hint}</p>
      )}
    </div>
  )
})

Input.displayName = 'Input'

export default Input
